import {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {useUser} from "../../../lib/hooks";
import {Container, Grid, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import {LoadingButton} from "../../../theme/components/LoadingButton";
import {PasswordRounded, TuneRounded, VisibilityOffRounded, VisibilityRounded} from "@mui/icons-material";
import {changePassword, changePersonalInformation} from "../../../lib/services/drive";
import Toasty from "../../../theme/components/Toasty";
import {setUserData} from "../../../lib/services/jwtService";

export default function Settings() {

    const user = useUser();
    const [inputValues, setInputValues] = useState({
        firstName: '',
        lastName: ''
    });
    const [inputErrors, setInputErrors] = useState(null);
    const [passwordValues, setPasswordValues] = useState({
        currentPassword: '',
        newPassword: '',
        newRPassword: '',
        showCurrentPassword: false,
        showNewPassword: false,
        showNewRPassword: false,
    });
    const [passwordErrors, setPasswordErrors] = useState(null);
    const [pending, setPending] = useState(false);
    const [changePasswordPending, setChangePasswordPending] = useState(false);

    const handleChange = (e) => {
        const {target: {value, name},} = e;
        setInputErrors(null);
        if (!value) setInputErrors({...inputErrors, [name]: "مقدار این فیلد نمی تواند خالی باشد"})
        setInputValues({...inputValues, [name]: value});
    }
    const handleChangePassInput = (e) => {
        const {target: {value, name},} = e;
        setPasswordErrors(null);
        if (!value) setPasswordErrors({...passwordErrors, [name]: "مقدار این فیلد نمی تواند خالی باشد"})
        setPasswordValues({...passwordValues, [name]: value});
    }
    const handleSubmit = async(e) => {
        e.preventDefault();
        setInputErrors(null);
        Object.keys(inputValues).forEach(i => {
            const value = inputValues[i];
            if (!value) setInputErrors({...inputErrors, [i]: "مقدار فیلد های خواسته شده خالی می باشد"});
        });
        if (inputErrors) return;
        setPending(true);
        const {data} = await changePersonalInformation(inputValues);
        if (data?.isSuccess) {
            const newUser = {...user};
            newUser.firstName = inputValues.firstName;
            newUser.lastName = inputValues.lastName;
            setUserData(JSON.stringify(newUser));
            if (data.successMessage) Toasty.success(data.successMessage);
            window.location.reload();
        } else {
            if (data && data.errors?.length) {
                data.errors.map(i => Toasty.error(i));
            }
        }
        setPending(false);
    }
    const handleChangePassword = async(e) => {
        e.preventDefault();
        setPasswordErrors(null);
        Object.keys(passwordValues).forEach(i => {
            const value = passwordValues[i];
            if (!value) setPasswordErrors({...passwordErrors, [i]: "مقدار فیلد های خواسته شده خالی می باشد"});
        });
        if (passwordErrors) return;
        setChangePasswordPending(true);
        const {data} = await changePassword({
                CurrentPassword: passwordValues.currentPassword,
                Password: passwordValues.newPassword,
                RePassword: passwordValues.newRPassword,
            });
        if (data?.isSuccess) {
            if (data.successMessage) Toasty.success(data.successMessage);
        } else {
            if (data && data.errors?.length) {
                data.errors.map(i => Toasty.error(i));
            }
        }
        setChangePasswordPending(false);
    }

    // Set default value of inputs to the user's current data
    useEffect(() => {
        if (user) {
            setInputValues({...inputValues, firstName: user.firstName, lastName: user.lastName})
        }
    }, []);

    return (
        <>
            <Helmet>
                <title>درایو میلفا - تنظیمات</title>
                </Helmet>
            <Container sx={{ mt: 3 }}>
                <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600}>تنظیمات پروفایل</Typography>
                <Grid mt={2} component="form" onSubmit={handleSubmit} noValidate container spacing={2}>
                    <Grid item xs={12} lg={3}>
                        <TextField
                            value={inputValues.firstName} onChange={handleChange}
                            name="firstName" fullWidth required
                            error={!!inputErrors?.firstName}
                            label="نام" placeholder="لطفا نام خود را وارد کنید"/>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <TextField
                            value={inputValues.lastName} onChange={handleChange}
                            name="lastName" fullWidth required
                            error={!!inputErrors?.lastName}
                            label="نام خانوادگی" placeholder="لطفا نام خانوادگی خود را وارد کنید"/>
                    </Grid>
                    <Grid item xs>
                        <LoadingButton
                            type="submit" loading={pending}
                            fullWidth disableElevation
                            sx={{ py: 1.5, height: "100%" }}
                            startIcon={<TuneRounded/>}>تغییر نام</LoadingButton>
                    </Grid>
                </Grid>
                <Typography mt={3} fontSize={{ xs: "1.1rem" }} fontWeight={600}>تغییر رمز</Typography>
                <Grid mt={2} component="form" onSubmit={handleChangePassword} noValidate container spacing={2}>
                    <Grid item xs={12} lg={3}>
                        <TextField
                            value={passwordValues.currentPassword} onChange={handleChangePassInput}
                            error={!!passwordErrors?.currentPassword}
                            fullWidth name="currentPassword" type={passwordValues.showCurrentPassword ? 'text' : 'password'}
                            label="رمز عبور فعلی" placeholder="رمز عبور فعلی خود را وارد کنید" required
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="start">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setPasswordValues({...passwordValues, showCurrentPassword: !passwordValues.showCurrentPassword})}
                                            onMouseDown={(e) => e.preventDefault()}
                                            edge="end">
                                            {passwordValues.showCurrentPassword ? <VisibilityOffRounded/> :
                                                <VisibilityRounded/>}
                                        </IconButton>
                                    </InputAdornment>
                            }}/>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <TextField
                            value={passwordValues.newPassword} onChange={handleChangePassInput}
                            error={!!passwordErrors?.newPassword}
                            fullWidth name="newPassword" type={passwordValues.showNewPassword ? 'text' : 'password'}
                            label="رمز عبور جدید" placeholder="رمز عبور جدید خود را وارد کنید" required
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="start">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setPasswordValues({...passwordValues, showNewPassword: !passwordValues.showNewPassword})}
                                            onMouseDown={(e) => e.preventDefault()}
                                            edge="end">
                                            {passwordValues.showNewPassword ? <VisibilityOffRounded/> :
                                                <VisibilityRounded/>}
                                        </IconButton>
                                    </InputAdornment>
                            }}/>
                    </Grid>
                    <Grid item xs={12} lg={3}>
                        <TextField
                            value={passwordValues.newRPassword} onChange={handleChangePassInput}
                            error={!!passwordErrors?.newRPassword}
                            fullWidth name="newRPassword" type={passwordValues.showNewRPassword ? 'text' : 'password'}
                            label="تکرار رمز عبور جدید" placeholder="تکرار رمز عبور جدید خود را وارد کنید" required
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="start">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setPasswordValues({...passwordValues, showNewRPassword: !passwordValues.showNewRPassword})}
                                            onMouseDown={(e) => e.preventDefault()}
                                            edge="end">
                                            {passwordValues.showNewRPassword ? <VisibilityOffRounded/> :
                                                <VisibilityRounded/>}
                                        </IconButton>
                                    </InputAdornment>
                            }}/>
                    </Grid>
                    <Grid item xs>
                        <LoadingButton
                            type="submit" loading={changePasswordPending}
                            fullWidth disableElevation
                            sx={{ py: 1.5, height: "100%" }}
                            startIcon={<PasswordRounded/>}>تغییر رمز</LoadingButton>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}